import { render, staticRenderFns } from "./risk-and-adressing.vue?vue&type=template&id=015972a4"
import script from "./risk-and-adressing.vue?vue&type=script&lang=js"
export * from "./risk-and-adressing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports